import { styled } from '@mui/material/styles'

import { GridWrapper } from '../wrapper'

export const GridGeneric = styled(GridWrapper)(() => ({
  paddingLeft: '30px',
}))
